import React from 'react';
export function Doctors() {
  return <section id="meet-the-doctors" className="py-24 bg-white" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4" data-id="element-10">
        <h2 className="text-3xl font-bold text-[#0F2C59] mb-16 text-center" data-id="element-11">
          MEET YOUR CLINICAL SPECIALISTS
        </h2>

        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-12">
          <div className="flex flex-col md:flex-row gap-8 items-center bg-slate-50 p-8 rounded-[12px]" data-id="element-13">
            <div className="w-48 h-48 rounded-[12px] overflow-hidden flex-shrink-0 shadow-lg" data-id="element-14">
              <img src="https://images.unsplash.com/photo-1559839734-2b71f1536783?auto=format&fit=crop&q=80&w=400" alt="Dr. Simbarashe Parirenyatwa" className="w-full h-full object-cover" data-id="element-15" />
            </div>
            <div data-id="element-16">
              <h3 className="text-2xl font-bold text-[#0F2C59] mb-1" data-id="element-17">
                Dr. Simbarashe Parirenyatwa, DDS
              </h3>
              <p className="text-[#4F709C] font-semibold mb-4" data-id="element-18">
                Lead Clinical Practitioner
              </p>
              <p className="text-slate-600 text-sm leading-relaxed" data-id="element-19">
                <span className="font-bold" data-id="element-20">Specialty:</span> Advanced Implants
                & Restorative Sedation Care. With over 15 years of experience in
                complex oral rehabilitation.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-center bg-slate-50 p-8 rounded-[12px]" data-id="element-21">
            <div className="w-48 h-48 rounded-[12px] overflow-hidden flex-shrink-0 shadow-lg" data-id="element-22">
              <img src="https://images.unsplash.com/photo-1622253692010-333f2da6031d?auto=format&fit=crop&q=80&w=400" alt="Dr. Simons" className="w-full h-full object-cover" data-id="element-23" />
            </div>
            <div data-id="element-24">
              <h3 className="text-2xl font-bold text-[#0F2C59] mb-1" data-id="element-25">
                Dr. Simons, DDS
              </h3>
              <p className="text-[#4F709C] font-semibold mb-4" data-id="element-26">
                Orthodontic & Cosmetic Specialist
              </p>
              <p className="text-slate-600 text-sm leading-relaxed" data-id="element-27">
                <span className="font-bold" data-id="element-28">Specialty:</span> Platinum
                Invisalign Provider & Aesthetic Veneers. Focused on creating
                perfectly balanced, natural smiles.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}